/* global mapOpts */

import loadGoogleMapsAPI from './loadGoogleMapsAPI';
import PropertyMap from './PropertyMap';

let googleMapsAPIKey;
if (mapOpts && mapOpts.mapApiKey.length > 12) {
    googleMapsAPIKey = mapOpts.mapApiKey;
} else {
    googleMapsAPIKey = 'AIzaSyBWDpbTeA2BbH3U-URJHvayCs7ckO-iCms';
}
const propertyMapContainer = document.querySelector('.property-location-map');

if (propertyMapContainer) {
    let propertyCoords = propertyMapContainer.dataset.coords;
    let dataZoom = propertyMapContainer.dataset.zoom;
    let propertyZoom = 14;
    if(dataZoom) {
        propertyZoom = dataZoom;
    }
    loadGoogleMapsAPI({key: googleMapsAPIKey}).then(() => {
        new PropertyMap(
            propertyMapContainer,
            propertyCoords,
            propertyZoom,
            propertyCoords,
            );
    }).catch((e) => {
        console.error(e);
    });
}


// WEBPACK FOOTER //
// ./assets/js/src/modules/maps.js